module.exports = __webpack_public_path__ + "1af65f4b1dde91fb8c26959a2e4a263b.gif";